<template>
	<div style="background: #fff" class="p-3 h-100 animated fadeIn">
		<b-card>
			<div slot="header">
				<strong>{{config.header}} 등록/수정</strong>
			</div>
			<b-form v-on:submit="submitHandling">
				<!--<draggable v-model="pgmAdDtoList">-->
					<b-card :border-variant="isEnded(data.endTime) ? 'danger' : ''" v-for="(data, index) in pgmAdDtoList" :key="index">
						<b-form-group>
							<div class="vSelectWrapper">
								<v-select v-if="is('playGameSnackgame')" v-model="data.viewInfo" @input="checkSnackDto(data.viewInfo, index)" label="name" :options="gameList" placeholder="모바일게임 이름을 입력해주세요.">
									<template slot="no-options">검색 결과가 없습니다.</template>
								</v-select>
								<v-select v-if="is('playGameRecommend')" v-model="data.appName" @input="checkRecommendDto(data.appName, index)" label="name" :options="gameList" placeholder="모바일게임 이름을 입력해주세요.">
									<template slot="no-options">검색 결과가 없습니다.</template>
								</v-select>
							</div>
						</b-form-group>
						<b-form-group>
							<b-form-group label="시작" label-for="startTime" :horizontal="true" :label-cols="1">
								<date-picker :id="'startTime' + index" required :value="data.startTime" v-on:input="data.startTime = new Date($event)" @dp-change="onStartChangeDate(index, $event.date)" :config="dateOptions"></date-picker>
							</b-form-group>
							<b-form-group label="종료" label-for="endTime" :horizontal="true" :label-cols="1">
								<date-picker :id="'endTime' + index" required :value="data.endTime" v-on:input="data.endTime = new Date($event)" :config="endDateOptions[index]"></date-picker>
							</b-form-group>
							<b-button class="d-inline-block ml-2 float-right" @click="removeItem(index)" variant="danger">삭제</b-button>
							<b-button v-if="isEnded(data.endTime)" class="d-inline-block ml-2 float-right" disabled variant="outline-danger">노출이 종료되었습니다.</b-button>
						</b-form-group>
					</b-card>
				<!--</draggable>-->
				<b-button @click="addItem" variant="outline-primary">추가</b-button>
				<b-button class="float-right" type="button" variant="outline-secondary" v-on:click="$router.go(-1)">뒤로</b-button>
				<b-button class="float-right" type="submit" variant="outline-primary">등록</b-button>
			</b-form>
		</b-card>
	</div>
</template>
<script>
	import draggable from 'vuedraggable'
	import { mapGetters, mapMutations } from 'vuex'
	import { MODULE_NAME as PGM_MODULE } from '@/store/playGame/actions.type'
	import { $showModalWithErrorMsg } from '@/common/util'
	import { labelClasses, DISPLAY_STATE } from '@/constants'
	import { SHOW_MODAL } from '@/store/ui/mutations.type'
	import playGameService from '@/common/api/playGame.service'
    export default {
        props: {
            config: {
                type: Object,
                required: true
            },
            registeredList: {
                type: Array,
                required: true
            },
            gameList: {
                type: Array,
                required: true
            }
        },
        components: {
            draggable
        },
        data() {
            return {
                pgmAdDtoList: [],
                labelClasses: labelClasses,
                isNewItem: false,
                pgmAdDto: {
                    appMasterId: 0,
                    appName: '',
                    endTime: '',
                    startTime: '',
                    title: '',
                    displayYn: DISPLAY_STATE.ON,
                    viewInfo: {
                        name: ''
                    },
                    orderNo: 1
                },
                endDateOptions: [],
                dateOptions: {
                    format: 'YYYY-MM-DD HH:mm:ss',
                    sideBySide: true,
                },
            }
        },
        methods: {
            onStartChangeDate (index, date) {
                if (!date) {
                    return
                }
                date = new Date(date)
                this.$set(this.endDateOptions[index], 'minDate', date)
            },
            checkSnackDto (data, index) {
                if (!data || !data.snackId) {
                    return
                }

                let count = 0
                for (let i = 0; i < this.pgmAdDtoList.length; i++) {
                    const viewInfo = this.pgmAdDtoList[i].viewInfo
                    if (!viewInfo) {
                        continue
                    }

                    if (String(viewInfo.snackId) === String(data.snackId)) {
                        if (++count > 1) {
                            this.pgmAdDtoList[index].viewInfo = {name: ''}
                            alert('이미 등록된 아이템입니다.')
                            break
                        }
                    }
                }
            },
            checkRecommendDto (data, index) {
                if (!data) {
                    return
                }
                let newAppName = ''
                if (typeof(data) === 'object' && !!data.appNameInfo) {
                    newAppName = data.name
                } else {
                    newAppName = data
                }

                let count = 0
                for (let i = 0; i < this.pgmAdDtoList.length; i++) {
                    const listData = this.pgmAdDtoList[i].appName
                    let appName = ''
                    if (typeof(listData) === 'object' && !!listData.appNameInfo) {
                        appName = listData.name
                    } else {
                        appName = listData
                    }

                    if (!appName) {
                        continue
                    }

                    if (newAppName === appName) {
                        if (++count > 1) {
                            this.pgmAdDtoList[index].appName = {name: null}
                            alert('이미 등록된 아이템입니다.')
                            break
                        }
                    }
                }
            },
            submitHandling() {
                event.preventDefault()

                for (let i = 0; i < this.pgmAdDtoList.length; i++) {
                    let data = this.pgmAdDtoList[i]
                    if (this.is('playGameSnackgame')) {
                        if (!!data.viewInfo && !!data.viewInfo.snackId && !!data.startTime && !!data.endTime) {
                            this.makeSnackgameDto(data, i)
                        } else {
                            alert("선택하지 않은 항목이 있습니다.")
                            return;
                        }
                    } else {
                        if (typeof(data.appName) === 'string' && data.appName.length > 0 && !!data.startTime && !!data.endTime) {
                            this.makeRecommendDto(data, i)
                        } else if (!!data.appName && !!data.appName.appMasterId && !!data.startTime && !!data.endTime) {
                            this.makeRecommendDto(data, i)
                        } else {
                            alert("선택하지 않은 항목이 있습니다.")
                            return;
                        }
                    }
                }

                let success = () => {
                    this[SHOW_MODAL]({msg: '등록이 완료되었습니다.', okHandling: () => {this.$router.push({name: this.config.type + 'List'})}})
                }
                let fail = () => {
                    $showModalWithErrorMsg.bind(this)
                }

                if (this.is('playGameSnackgame')) {
                    playGameService.postSnackgame({list : this.pgmAdDtoList}).then(success).catch(fail)
                } else {
                    playGameService.postRecommend({list: this.pgmAdDtoList}).then(success).catch(fail)
                }
            },
            makeSnackgameDto (data, index) {
                let snackGame = data.viewInfo
                data.appMasterId = snackGame.snackId
                data.appName = snackGame.name
                data.title = snackGame.name
                // data.orderNo = index + 1
                data.modUserId = null
            },
            makeRecommendDto (data, index) {
                let recommend = data.appName
                if (typeof (recommend) === 'object') {
                    data.appMasterId = recommend.appMasterId
                    data.appName = recommend.name
                    data.title = recommend.name
                    data.modUserId = null
                }
                // data.orderNo = index + 1
                data.viewInfo = {}
            },
            isEnded (date) {
                if (!!date) {
                    let endTime = new Date(date).getTime()
                    let now = new Date().getTime()
                    return now >= endTime
                } else {
                    return false
                }
            },
            removeItem (index) {
                this.pgmAdDtoList.splice(index, 1)
            },
            addItem() {
                this.endDateOptions.push(Object.assign({}, this.dateOptions))
                this.pgmAdDtoList.push(Object.assign({}, this.pgmAdDto))
            },
            is(type) {
                return type === this.config.type
            },
            ...mapMutations('ui', [SHOW_MODAL])
        },
        watch: {
            registeredList(data) {
                let len = data.length
                for (let i = len - 1; i >=0; i--) {
                    this.pgmAdDtoList.push(data[i])
                    this.endDateOptions.push(Object.assign({minDate: data[i].startTime}, this.dateOptions))
                }
            },
        }
    }
</script>
<style>
	.vSelectWrapper .dropdown-toggle:after {
		display: none !important;
	}
</style>
